const HeaderSocials = () => {
  return (
    <div className="home__socials">
      <a
        href="https://www.instagram.com"
        className="home__social-link"
        rel="noopener noreferrer"
        target="_blank"
      >
        <i className="icon-social-instagram"></i>
      </a>

      <a
        href="https://www.twitter.com"
        className="home__social-link"
        target="_blank"
        rel="noopener noreferrer"
      >
        <i className="icon-social-twitter"></i>
      </a>

      {/* <a
        href="https://www.behance.com"
        className="home__social-link"
        target="_blank"
        rel="noopener noreferrer"
      >
        <i className="icon-social-behance"></i>
      </a> */}

      <a
        href="https://www.facebook.com"
        className="home__social-link"
        target="_blank"
        rel="noopener noreferrer"
      >
        <i className="icon-social-facebook"></i>
      </a>

      <a
        href="https://www.linkedin.com/in/abdulaziz-rustamov-530560343/"
        className="home__social-link"
        target="_blank"
        rel="noopener noreferrer"
      >
        <i className="icon-social-linkedin"></i>
      </a>
    </div>
  );
};

export default HeaderSocials;
